<template>
  <div class=""
       @dragover="dragover"
       @dragleave="dragleave"
       @drop="drop">
    <div class="upload-box-mini glow"
    >

      <form>
        <input
            type="file"
            multiple
            name="file"
            id="fileInput"
            class="hidden-input"
            @change="onChange"
            ref="file"
        />
      </form>

      <div class="upload-box-inner">
        <div>
          <i data-v-006c151a="" class="fa fa-cloud-upload-alt fa-5x vue-uploadbox-icon"></i>
        </div>
        <div class="font-weight-bold">
          <label for="fileInput" class="file-label" >
            <div v-if="isDragging">Release to drop files here.</div>
            <div v-else style="color:#ccc">Drop files here or <u>click here</u> to upload.</div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';
import TextInput from "../../../form/TextInput.vue";
import JobManager from "../../manager/JobManager";
import SimiliarImageManager from "../../manager/SimiliarImageManager";

export default {
  name: 'UploadBox',
  props: {},
  components: {TextInput},
  mixins: [store, currentJob],
  data() {
    return {
      isDragging: false,
      files: [],
      loadingState: 'ready',
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    performPreviewConversion() {
      let testJob = this.currentJob;
        SimiliarImageManager.loadOriginalImage(this.currentJob, this.files);
    },
    onChange() {
      this.files = [...this.$refs.file.files];
      this.performPreviewConversion();
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.upload-box-mini {
  border: 1px solid #333333;
  border-radius: 4px;
  background: #2E2E2E;
  height: 200px;
  padding: 10px;

  .upload-box-inner {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-radius: 4px;
    height: 100%;
    background: #383838;
    border: 2px dashed #666;
  }
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  display: block;
  cursor: pointer;
}

</style>
